import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Emails/Check';

const { displayName } = config;

function EmailCheck(): React.JSX.Element {
  document.title = `${displayName}: Просмотр шаблона`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}

export default EmailCheck;
